export default __webpack_public_path__ + "static/media/arrow-left-1.364f9d11.svg";